export const DASHBOARD_MODULE_SET = "dashboard::module::set";

export const POLICY_EDITOR_PAGE_SET = "policy-editor::page:set";
export const POLICY_EDITOR_JSON_TEXT_SET = "policy-editor::json::text::set";
export const POLICY_EDITOR_JSON_SRC_SET = "policy-editor::json::src::set";
export const POLICY_EDITOR_JSON_VISIT = "policy-editor::json::visit";
export const POLICY_EDITOR_UI_SHOW_DEFAULT_POLICY_SET =
  "policy-editor::ui::default-policy::show::set";
